import React, { useState } from 'react';
import { ArrowLeftIcon, PackageIcon, PackagePlusIcon, PackageXIcon } from 'lucide-react';
import { StorageScanner } from './StorageScanner';
import { StorageVisualization } from './StorageVisualization';
import { StorageOrderOverview } from './StorageOrderOverview';
interface TKStorageModuleProps {
  onBackToOverview?: () => void;
}
export function TKStorageModule({
  onBackToOverview
}: TKStorageModuleProps) {
  // Erweitere den View-State um 'orderOverview' für die Anzeige der Auftragsübersicht
  const [view, setView] = useState<'operationType' | 'orderOverview' | 'scan' | 'visualization'>('operationType');
  const [operationType, setOperationType] = useState<'storage' | 'retrieval' | null>(null);
  const [scannedLocation, setScannedLocation] = useState<string | null>(null);
  const [selectedPositions, setSelectedPositions] = useState<{
    [key: string]: boolean;
  }>({});
  const [selectedOrder, setSelectedOrder] = useState<string | null>(null);
  const handleOperationTypeSelect = (type: 'storage' | 'retrieval') => {
    setOperationType(type);
    if (type === 'storage') {
      setView('scan');
    } else {
      // Bei Auslagerung zur Auftragsübersicht wechseln
      setView('orderOverview');
    }
  };
  const handleOrderSelect = (orderId: string) => {
    setSelectedOrder(orderId);
    setView('scan');
  };
  const handleScanComplete = (locationCode: string) => {
    setScannedLocation(locationCode);
    setView('visualization');
  };
  const handleBackToScan = () => {
    setView('scan');
    setScannedLocation(null);
    setSelectedPositions({});
  };
  const handleBackToOperationType = () => {
    setView('operationType');
    setOperationType(null);
    setScannedLocation(null);
    setSelectedPositions({});
    setSelectedOrder(null);
  };
  const handleBackToOrderOverview = () => {
    setView('orderOverview');
    setScannedLocation(null);
    setSelectedPositions({});
  };
  const handlePositionSelect = (positions: {
    [key: string]: boolean;
  }) => {
    setSelectedPositions(positions);
  };
  return <div className="container mx-auto" data-id="element-2326">
      <div className="mb-8" data-id="element-2327">
        <div data-id="element-2328">
          <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-2329">TK-Lager</h2>
          <p className="text-gray-600 mb-4" data-id="element-2330">
            Verwaltung und Überwachung des Tiefkühllagers
          </p>
          {onBackToOverview && <button onClick={onBackToOverview} className="flex items-center gap-2 text-gray-600 hover:text-gray-800" data-id="element-2331">
              
              
            </button>}
        </div>
      </div>
      {view === 'operationType' ? <div className="bg-white rounded-xl shadow-md p-8" data-id="element-2332">
          <div className="max-w-md mx-auto text-center mb-8" data-id="element-2333">
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2334">
              Lagervorgang auswählen
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-2335">
              Bitte wählen Sie, ob Sie eine Einlagerung oder Auslagerung
              durchführen möchten.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto" data-id="element-2336">
            <div onClick={() => handleOperationTypeSelect('storage')} className="bg-white border-2 border-blue-200 hover:border-blue-400 rounded-xl p-6 text-center cursor-pointer transition-all hover:shadow-md" data-id="element-2337">
              <div className="bg-blue-100 p-4 rounded-full inline-flex mb-4" data-id="element-2338">
                <PackagePlusIcon size={48} className="text-blue-600" data-id="element-2339" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-2340">
                Einlagerung
              </h4>
              <p className="text-gray-600" data-id="element-2341">
                Neue Produkte in das TK-Lager einlagern und Lagerplätze
                zuweisen.
              </p>
            </div>
            <div onClick={() => handleOperationTypeSelect('retrieval')} className="bg-white border-2 border-amber-200 hover:border-amber-400 rounded-xl p-6 text-center cursor-pointer transition-all hover:shadow-md" data-id="element-2342">
              <div className="bg-amber-100 p-4 rounded-full inline-flex mb-4" data-id="element-2343">
                <PackageXIcon size={48} className="text-amber-600" data-id="element-2344" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-2345">
                Auslagerung
              </h4>
              <p className="text-gray-600" data-id="element-2346">
                Produkte aus dem TK-Lager entnehmen und Lagerplätze freigeben.
              </p>
            </div>
          </div>
          <div className="max-w-md mx-auto mt-8" data-id="element-2347">
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-2348">
              <h4 className="font-medium text-gray-700 mb-2" data-id="element-2349">Hinweis:</h4>
              <p className="text-sm text-gray-600" data-id="element-2350">
                Wählen Sie die gewünschte Operation aus, um fortzufahren.
                Anschließend scannen Sie den QR-Code des entsprechenden
                Lagerplatzes.
              </p>
            </div>
          </div>
        </div> : view === 'orderOverview' ? <StorageOrderOverview onBack={handleBackToOperationType} onOrderSelect={handleOrderSelect} data-id="element-2351" /> : view === 'scan' ? <div data-id="element-2352">
          <button onClick={operationType === 'retrieval' ? handleBackToOrderOverview : handleBackToOperationType} className="flex items-center gap-2 text-gray-600 hover:text-gray-800 mb-4" data-id="element-2353">
            <ArrowLeftIcon size={16} data-id="element-2354" />
            <span data-id="element-2355">
              Zurück{' '}
              {operationType === 'retrieval' ? 'zur Auftragsübersicht' : 'zur Auswahl'}
            </span>
          </button>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6" data-id="element-2356">
            <div className="flex items-center" data-id="element-2357">
              {operationType === 'storage' ? <>
                  <PackagePlusIcon size={20} className="text-blue-600 mr-2" data-id="element-2358" />
                  <h3 className="font-medium text-blue-800" data-id="element-2359">
                    Einlagerung: Bitte scannen Sie den Ziel-Lagerplatz
                  </h3>
                </> : <>
                  <PackageXIcon size={20} className="text-amber-600 mr-2" data-id="element-2360" />
                  <h3 className="font-medium text-amber-800" data-id="element-2361">
                    Auslagerung: Bitte scannen Sie den Quell-Lagerplatz
                    {selectedOrder && ` für Auftrag #${selectedOrder}`}
                  </h3>
                </>}
            </div>
          </div>
          <StorageScanner onScanComplete={handleScanComplete} data-id="element-2362" />
        </div> : <StorageVisualization locationCode={scannedLocation || ''} onBack={handleBackToScan} onPositionSelect={handlePositionSelect} selectedPositions={selectedPositions} operationType={operationType} orderId={selectedOrder} data-id="element-2363" />}
    </div>;
}